import { useNavigate, useLocation } from 'react-router-dom';
import { Home, User } from 'lucide-react';
import './Navigation.css';

export default function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="navigation">
      <button 
        className={`nav-button ${location.pathname === '/dashboard' ? 'nav-button-active' : ''}`}
        onClick={() => navigate('/dashboard')}
      >
        <Home size={24} />
        <span>タイムライン</span>
      </button>
      <button 
        className={`nav-button ${location.pathname === '/mypage' ? 'nav-button-active' : ''}`}
        onClick={() => navigate('/mypage')}
      >
        <User size={24} />
        <span>マイページ</span>
      </button>
    </nav>
  );
}